import { z } from 'zod';

export const nhanVienSchema = z.object({
  ma_nhan_vien: z.string().optional().nullable(),
  ho_ten_nhan_vien: z.string().optional().nullable(),
  chuc_vu: z.string().optional().nullable(),
  ma_bo_phan: z.string().optional().nullable(),
  gioi_tinh: z.string().optional().nullable(),
  ngay_sinh: z.string().optional().nullable(),
  noi_sinh: z.string().optional().nullable(),
  dia_chi: z.string().optional().nullable(),
  dien_thoai: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  so_cmnd: z.string().optional().nullable(),
  ngay_hieu_luc_cmnd: z.string().optional().nullable(),
  noi_cap_cmnd: z.string().optional().nullable(),
  nhan_vien_ban_hang: z.boolean().optional().nullable(),
  nhan_vien_mua_hang: z.boolean().optional().nullable(),
  cong_no_tam_ung: z.boolean().optional().nullable()
});

export type NhanVienFormValues = z.infer<typeof nhanVienSchema>;

export const initialValues: NhanVienFormValues = {
  ma_nhan_vien: '',
  ho_ten_nhan_vien: '',
  chuc_vu: '',
  ma_bo_phan: '',
  gioi_tinh: '1',
  ngay_sinh: '',
  noi_sinh: '',
  dia_chi: '',
  dien_thoai: '',
  email: '',
  so_cmnd: '',
  ngay_hieu_luc_cmnd: '',
  noi_cap_cmnd: '',
  nhan_vien_ban_hang: true,
  nhan_vien_mua_hang: true,
  cong_no_tam_ung: true
};
